<template>
  <div v-if="visible">
    <div class="pi-overlay" @click="close"></div>
    <div
      class="pi-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pi-title"
    >
      <button class="pi-close" @click="close" aria-label="閉じる">×</button>
      <h2 id="pi-title" class="pi-title">会員サービスのご案内</h2>
      <p class="pi-body">
        さらに充実した会員サービスで、便利な機能や特典をご利用いただけます！
      </p>
      <div class="pi-actions">
        <button class="pi-secondary" @click="close">あとで</button>
        <a class="pi-cta" href="/register/plan_select">今すぐ登録</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupInvite",
  props: {
    // 'guest' | 'standard' | 'premium'
    userType: { type: String, required: true },
    // 例: 3（日）。null/undefined の場合は表示しない
    intervalDays: { type: Number, default: null },
    // 管理画面の有効/無効
    enabled: { type: Boolean, required: true },
    // ディレイ表示（ミリ秒）
    delayMs: { type: Number, default: 10000 }
  },

  data() {
    return { visible: false, delayTid: null, shownOnceInThisLoad: false };
  },
  computed: {
    // localStorageに保存するキー名
    storageKey() {
      return `popup_last_shown_at_${this.userType}`;
    }
  },

  mounted() {
    if (!this.enabled || this.intervalDays == null) return;

    // 保存可否チェック：localStorage が使えない環境では出さない
    if (!this.canUseLocalStorage()) return;

    const last = this.safeGet(this.storageKey);

    // 同一ページ表示中は一度だけ
    if (this.shownOnceInThisLoad) return;

    if (!this.shouldShowByInterval(this.intervalDays, last)) return;

    this.shownOnceInThisLoad = true;

    // ポップアップを遅延表示
    this.delayTid = setTimeout(() => {
      this.open();
    }, this.delayMs);
  },

  beforeDestroy() {
    this.cleanup();
  },
  // 念のため
  destroyed() {
    this.cleanup();
  },

  methods: {
    // localStorage 利用可否（set/remove まで成功するか）を確認
    canUseLocalStorage() {
      try {
        const k = "__popup_probe__";
        localStorage.setItem(k, "1");
        localStorage.removeItem(k);
        return true;
      } catch (e) {
        return false;
      }
    },
    safeGet(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    safeSet(key, value) {
      try {
        localStorage.setItem(key, value);
        return true;
      } catch (e) {
        return false;
      }
    },
    // 経過日数計算
    daysDiff(fromISO) {
      const t = new Date(fromISO).getTime();
      if (!isFinite(t)) return Infinity; // 壊れ値は「未表示扱い」
      return (Date.now() - t) / 86400000; // ミリ秒から日数に変換
    },
    // 対象会員種別の表示間隔日数と前回表示からの経過日数を元にポップアップ表示するかチェック
    shouldShowByInterval(days, last) {
      // days が 0 以下なら常に表示可能と解釈（負値の事故防止）
      if (days <= 0) return true;
      if (!last) return true;
      return this.daysDiff(last) >= Number(days || 0);
    },

    open() {
      if (this.visible) return; // 多重発火防止
      this.visible = true;
      document.documentElement.classList.add("popup-open");
      document.addEventListener("keydown", this.onKeydown);
    },

    close() {
      this.visible = false;
      document.documentElement.classList.remove("popup-open");
      document.removeEventListener("keydown", this.onKeydown);
      this.safeSet(this.storageKey, new Date().toISOString());
      if (this.delayTid) {
        clearTimeout(this.delayTid);
        this.delayTid = null;
      }
    },

    // エスケープボタン押下時もポップアップを閉じる
    onKeydown(e) {
      if (e.key === "Escape") this.close();
    },

    // ポップアップクローズ時のクリーンアップ処理（念のため）
    cleanup() {
      document.documentElement.classList.remove("popup-open");
      document.removeEventListener("keydown", this.onKeydown);
      if (this.delayTid) {
        clearTimeout(this.delayTid);
        this.delayTid = null;
      }
    }
  }
};
</script>

<style scoped>
.pi-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}
.pi-modal {
  position: fixed;
  z-index: 100;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(92vw, 520px);
  background: #fff;
  border-radius: 14px;
  padding: 20px 22px 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
.pi-close {
  position: absolute;
  right: 8px;
  top: 6px;
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
}
.pi-title {
  margin: 4px 0 8px;
  font-size: 20px;
  font-weight: 700;
}
.pi-body {
  margin: 0 0 16px;
  line-height: 1.6;
}
.pi-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pi-cta {
  display: inline-block;
  padding: 10px 14px;
  border-radius: 8px;
  background: #2d8cff;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.pi-secondary {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}
</style>
